import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-single-view-driver-popup',
  templateUrl: './single-view-driver-popup.component.html',
  styleUrls: ['./single-view-driver-popup.component.scss'],
})
export class SingleViewDriverPopupComponent implements OnInit {
  @Output() viewDriverOnchange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible: boolean = false;
  @Input() driverData: any;

  constructor() {}

  handleCancel(): void {
    this.isVisible = false;
    this.viewDriverOnchange.emit({
      name: 'isVisible',
      value: false,
    });
  }

  ngOnInit(): void {}
}
